import { render, staticRenderFns } from "./BundleDataLayout3.vue?vue&type=template&id=fabf4770&"
import script from "./BundleDataLayout3.vue?vue&type=script&lang=js&"
export * from "./BundleDataLayout3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports